import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/home.vue';
import About from '../views/about.vue';
import Contact from '../views/contact.vue';
import Caledily from '../components/calendily.vue';
import Report from '../views/ReportPage.vue';
import Dictionary from '../views/dictionary.vue';
import OnlineSignals from '../views/onlineSignals.vue';
import Login from '../views/login.vue';
import LoginSignals from '../views/login-signals.vue';
import Register from '../views/register.vue';
import Dashboard from '../views/dashboard.vue';
import NotFoundView from '../components/NotFound.vue';
import Services from '../views/Services/ServicesPage.vue';
import BusinessOwner from '../views/Services/Services-business-owner.vue';
import OrganizationalServices from '../views/Services/Organizational-services.vue';
import ServicesManufacturers from '../views/Services/Services-manufacturers.vue';
import MerchantServices from '../views/Services/Merchant-services.vue';
import TradersServices from '../views/Services/Traders-services.vue';
import TechnologyConsulting from '../views/Services/Technology-consulting.vue';
import DataManagementService from '../views/Services/Data-management-service.vue';
import Academy from '../views/academy/academy.vue';
import Category from '../views/academy/category.vue';
import Period from '../views/academy/period.vue';
import TradeAssistant from '../views/traders/trade-assistant.vue';
import VipClub from '../views/vipClub.vue';
import ReportView from '../views/traders/report.vue';
import Tests from '../views/tests.vue';

import EnHome from '../views/en/home-en.vue';
import EnAbout from '../views/en/about-en.vue';
import EnContact from '../views/en/contact-en.vue';
import EnCaledily from '../components/calendily.vue';
import EnReport from '../views/ReportPage.vue';
import EnDictionary from '../views/dictionary.vue';
import EnLogin from '../views/en/login-en.vue';
import EnLoginSignals from '../views/en/login-signals-en.vue';
import EnRegister from '../views/en/register-en.vue';
import EnDashboard from '../views/en/dashboard-en.vue';
import EnNotFoundView from '../components/NotFound.vue';
import EnServices from '../views/en/Services/ServicesPage-en.vue';
import EnBusinessOwner from '../views/en/Services/Services-business-owner-en.vue';
import EnOrganizationalServices from '../views/en/Services/Organizational-services-en.vue';
import EnServicesManufacturers from '../views/en/Services/Services-manufacturers-en.vue';
import EnMerchantServices from '../views/en/Services/Merchant-services-en.vue';
import EnTradersServices from '../views/en/Services/Traders-services-en.vue';
import EnTechnologyConsulting from '../views/en/Services/Technology-consulting-en.vue';
import EnDataManagementService from '../views/en/Services/Data-management-service-en.vue';
import EnAcademy from '../views/en/academy/academy-en.vue';
import EnCategory from '../views/en/academy/category-en.vue';
import EnPeriod from '../views/en/academy/period-en.vue';
import EnTradeAssistant from '../views/en/traders/trade-assistant-en.vue';
import EnVipClub from '../views/en/vipClub-en.vue';
import EnReportView from '../views/en/traders/report-en.vue';
import EnTests from '../views/en/tests-en.vue';


let routes: Array<RouteRecordRaw> = [];

if (!localStorage.getItem('lang')||localStorage.getItem('lang')=='fa') {
  routes = [
    {
      path: '',
      name: 'home',
      component: Home
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: Login
    },
    {
      path: '/sign-in-signals',
      name: 'sign-in-signals',
      component: LoginSignals
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: Register
    },
    {
      path: '/report-view',
      name: 'report-view',
      component: ReportView
    },
    {
      path: '/dashboard/:id',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/services/',
      children: [
        {
          path: '',
          name: 'services',
          component: Services,      
        },
        {
          path: 'business-owner',
          name: 'business-owner',
          component: BusinessOwner
        },
        {
          path: 'organizational-services',
          name: 'organizational-services',
          component: OrganizationalServices
        },
        {
          path: 'services-manufacturers',
          name: 'services-manufacturers',
          component: ServicesManufacturers
        },
        {
          path: 'merchant-services',
          name: 'merchant-services',
          component: MerchantServices
        },
        {
          path: 'traders-services',
          name: 'traders-services',
          component: TradersServices
        },
        {
          path: 'technology-consulting-service',
          name: 'technology-consulting-service',
          component: TechnologyConsulting
        },
        {
          path: 'data-management-service',
          name: 'data-management-service',
          component: DataManagementService 
        },
      ]
    },
    {
      path: '/academy/',
      children: [
        {
          path: '',
          name: 'academy',
          component: Academy,      
        },
        {
          path: 'category',
          name: 'category',
          component: Category,      
        },
        {
          path: 'period',
          name: 'period',
          component: Period,      
        },
      ]
    },
    {
      path: '/trade/',
      children: [
        {
          path: 'trade-assistant',
          name: 'trade-assistant',
          component: TradeAssistant,      
        },
      ]
    },
    {
      path: '/vip-club',
      name: 'vip-club',
      component: VipClub
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/caledily',
      name: 'caledily',
      component: Caledily
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/dictionary',
      name: 'dictionary',
      component: Dictionary
    },
    {
      path: '/online-signals/:id',
      name: 'online-signals',
      component: OnlineSignals
    },
    {
      path: '/tests',
      name: 'tests',
      component: Tests
    },
  {
    path: "/:pathMatch(.*)*", // این مسیر هر آدرسی که پیدا نشود را می‌گیرد
    component: NotFoundView, // کامپوننت صفحه 404
  },
  ]
}
else if (localStorage.getItem('lang')=='en') {
  routes = [
    {
      path: '',
      name: 'home',
      component: EnHome
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: EnLogin
    },
    {
      path: '/sign-in-signals',
      name: 'sign-in-signals',
      component: EnLoginSignals
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: EnRegister
    },
    {
      path: '/report-view',
      name: 'report-view',
      component: EnReportView
    },
    {
      path: '/dashboard/:id',
      name: 'dashboard',
      component: EnDashboard
    },
    {
      path: '/about',
      name: 'about',
      component: EnAbout
    },
    {
      path: '/services/',
      children: [
        {
          path: '',
          name: 'services',
          component: EnServices,      
        },
        {
          path: 'business-owner',
          name: 'business-owner',
          component: EnBusinessOwner
        },
        {
          path: 'organizational-services',
          name: 'organizational-services',
          component: EnOrganizationalServices
        },
        {
          path: 'services-manufacturers',
          name: 'services-manufacturers',
          component: EnServicesManufacturers
        },
        {
          path: 'merchant-services',
          name: 'merchant-services',
          component: EnMerchantServices
        },
        {
          path: 'traders-services',
          name: 'traders-services',
          component: EnTradersServices
        },
        {
          path: 'technology-consulting-service',
          name: 'technology-consulting-service',
          component: EnTechnologyConsulting
        },
        {
          path: 'data-management-service',
          name: 'data-management-service',
          component: EnDataManagementService 
        },
      ]
    },
    {
      path: '/academy/',
      children: [
        {
          path: '',
          name: 'academy',
          component: EnAcademy,      
        },
        {
          path: 'category',
          name: 'category',
          component: EnCategory,      
        },
        {
          path: 'period',
          name: 'period',
          component: EnPeriod,      
        },
      ]
    },
    {
      path: '/trade/',
      children: [
        {
          path: 'trade-assistant',
          name: 'trade-assistant',
          component: EnTradeAssistant,      
        },
      ]
    },
    {
      path: '/vip-club',
      name: 'vip-club',
      component: EnVipClub
    },
    {
      path: '/contact',
      name: 'contact',
      component: EnContact
    },
    {
      path: '/caledily',
      name: 'caledily',
      component: Caledily
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/dictionary',
      name: 'dictionary',
      component: Dictionary
    },
    {
      path: '/online-signals/:id',
      name: 'online-signals',
      component: OnlineSignals
    },
    {
      path: '/tests',
      name: 'tests',
      component: EnTests
    },
  {
    path: "/:pathMatch(.*)*", // این مسیر هر آدرسی که پیدا نشود را می‌گیرد
    component: NotFoundView, // کامپوننت صفحه 404
  },
  ]
}


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // اگر کاربر دکمه برگشت را زده باشد، به موقعیت قبلی اسکرول می‌کند
    } else {
      return { left: 0, top: 0 }; // به ابتدای صفحه برو
    }
  }
})

export default router
